import React, { useState, useEffect } from "react";
import QuestsListElement from "../../assets/components/questListElement";
import { useNavigate } from "react-router";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";

const EventListElement = ({ event }) => {
  const navigate = useNavigate();
  const [hasTicket, setHasTicket] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkHasTicket();
  }, []);

  const clickHandler = async (event) => {
    if (!loading) {
      try {
        await appApi.get(`/event/prefillcheck/${event._id}`).then(() => {
          navigate(`/eventDetails/${event._id}`);
        });
      } catch (err) {
        errorHandler(err);
      }
      // if (hasTicket === null) {
      //   navigate(`/events/${event._id}`);
      // } else {
      //   navigate(`/ticket/${hasTicket._id}`, { replace: true });
      // }
      // navigate(`/eventDetails/${event._id}`);
    }
  };

  const checkHasTicket = async () => {
    setLoading(true);
    try {
      await appApi
        .post(`/eventTicket/getMyTicket`, {
          eventId: event._id,
        })
        .then(({ data }) => {
          setHasTicket(data.ticket);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  return (
    <QuestsListElement
      isEvent={true}
      score={null}
      title={`${event.name}  ${hasTicket !== null ? "(رزرو شده)" : ""}`}
      subTitle={event.subtitle}
      handleClick={() => clickHandler(event)}
    />
  );
};

export default EventListElement;
